export default "__VITE_ASSET__4ee8418c__"